import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

import Login from "../views/auth/Login";
import Register from "../views/auth/Register";
import ConfirmEmail from "../views/auth/ConfirmEmail";
import VerifyEmail from "../views/auth/VerifyEmail"
import ForgotPassword from "../views/auth/ForgotPassword";
import ResetPassword from "../views/auth/ResetPassword";

import Api from "../views/main/Api/Api";
import Orders from "../views/main/Orders/Orders";
import Order from "../views/main/Orders/Order";
import Drafts from "../views/main/Drafts/Drafts";
import DraftEditor from "../views/main/Drafts/DraftEditor";
import Complaints from "../views/main/Complaints/Complaints";
import Profile from "../views/main/Profile/Profile";
import GiveOuts from "../views/main/GiveOuts/GiveOuts"
import Systems from "../views/main/Systems/Systems"
import Blocks from "../views/main/Blocks/Blocks"
import Colors from "../views/main/Colors/Colors"
import Packages from "../views/main/Packages/Packages"
import Units from "../views/main/Units/Units";
import Clients from "../views/main/Clients/Clients";
import Messages from "../views/main/Messages/Messages";
import Tags from "../views/main/Tags/Tags";
import NotFound from "../views/errors/NotFound";
import Cookies from "js-cookie";
import OrderClosed from "../views/main/Orders/OrderClosed";
import Users from "../views/main/Users/Users.vue";

const opts = {
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.login',
                guards: ['guest']
            },
    },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.register',
                guards: ['guest']
            },
    },
        {
            path: '/forgot_password',
            name: 'forgot_password',
            component: ForgotPassword,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.password_recovery',
                guards: ['guest']
            },
    },
        {
            path: '/reset_password/:token',
            name: 'reset_password',
            component: ResetPassword,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.password_reset',
                guards: ['guest']
            },
    },
        {
            path: '/confirm_email',
            name: 'confirm_email',
            component: ConfirmEmail,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.email_confirmation',
                guards: ['auth', 'unverified']
            },
    },
        {
            path: '/email/verify/:id/:hash',
            name: 'verify_email',
            component: VerifyEmail,
            meta: {
                layout: 'blank-layout',
                title: 'plugins.router.titles.email_verification',
                guards: ['auth', 'unverified']
            },
    },
        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.orders',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.orders',
                        to: {name: 'orders'},
                },
                ],
            },
    },
        {
            path: '/orders/create',
            name: 'order_create',
            component: DraftEditor,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.order_new',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.orders',
                        to: {name: 'orders'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.order_new',
                        to: {name: 'order_create'},
                },
                ],
            },
    },
        {
            path: '/orders/:id',
            name: 'order_show',
            component: Order,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.order',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.orders',
                        to: {name: 'orders'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.order',
                        to: {name: 'order_show'},
                },
                ],
            },
    },
        {
            path: '/orders_closed/:id',
            name: 'order_closed_show',
            component: OrderClosed,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.order',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.orders',
                        to: {name: 'orders'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.order',
                        to: {name: 'order_closed_show'},
                },
                ],
            },
    },
        {
            path: '/orders/:id/edit',
            name: 'order_edit',
            component: DraftEditor,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.order_edit',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.orders',
                        to: {name: 'orders'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.order',
                        to: {name: 'order_show'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.order_edit',
                        to: {name: 'order_edit'},
                },
                ],
            },
    },
        {
            path: '/drafts',
            name: 'drafts',
            component: Drafts,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.drafts',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.drafts',
                        to: {name: 'drafts'},
                },
                ],
            },
    },
        {
            path: '/drafts/:id/edit',
            name: 'draft_edit',
            component: DraftEditor,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.draft_edit',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.drafts',
                        to: {name: 'drafts'},
                },
                    {
                        text: 'plugins.router.breadcrumbs.draft_edit',
                        to: {name: 'draft_edit'},
                },
                ],
            },
    },
        {
            path: '/complaints',
            name: 'complaints',
            component: Complaints,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.complaints',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.complaints',
                        to: {name: 'complaints'},
                },
                ],
            },
    },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.profile',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.profile',
                        to: {name: 'profile'},
                },
                ],
            },
    },
        {
            path: '/web_services',
            name: 'api',
            component: Api,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.web_services',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.web_services',
                        to: {name: 'api'},
                },
                ],
            },
    },
    {
            path: '/admin/give_outs',
            name: 'give_outs',
            component: GiveOuts,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.give_outs',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.give_outs',
                        to: {name: 'give_outs'},
                },
                ],
            },
    },
        {
            path: '/admin/systems',
            name: 'systems',
            component: Systems,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.systems',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.systems',
                        to: {name: 'systems'},
                },
                ],
            },
    },
        {
            path: '/admin/blocks',
            name: 'blocks',
            component: Blocks,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.blocks',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.blocks',
                        to: {name: 'blocks'},
                },
                ],
            },
    },
        {
            path: '/admin/colors',
            name: 'colors',
            component: Colors,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.colors',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.colors',
                        to: {name: 'colors'},
                },
                ],
            },
    },
        {
            path: '/admin/packages',
            name: 'packages',
            component: Packages,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.packages',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.packages',
                        to: {name: 'packages'},
                },
                ],
            },
    },
        {
            path: '/admin/units',
            name: 'units',
            component: Units,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.units',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.units',
                        to: {name: 'units'},
                },
                ],
            },
    },
        {
            path: '/admin/clients',
            name: 'clients',
            component: Clients,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.clients',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.clients',
                        to: {name: 'clients'},
                },
                ],
            },
    },
        {
            path: '/admin/messages',
            name: 'messages',
            component: Messages,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.messages',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.messages',
                        to: {name: 'messages'},
                },
                ],
            },
    },
        {
            path: '/admin/tags',
            name: 'tags',
            component: Tags,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.tags',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.tags',
                        to: {name: 'tags'},
                },
                ],
            },
    },
        {
            path: '/admin/users',
            name: 'users',
            component: Users,
            meta: {
                layout: 'main-layout',
                title: 'plugins.router.titles.users',
                guards: ['auth', 'verified'],
                breadcrumbs: [
                    {
                        text: 'plugins.router.breadcrumbs.users',
                        to: {name: 'users'},
                },
                ],
            },
    },
        {
            path: '/',
            redirect: {
                name: 'orders'
            }
    },
        {
            path: "*",
            name: 'not_found',
            component: NotFound,
            meta: {
                layout: 'blank-layout',
                title: 'Jarstol | 404',
                guards: []
            },
    }
    ]
}

const router = new VueRouter(opts);

router.beforeEach((to, from, next) => {

    if (to.meta.guards.includes('auth')) {
        if (Cookies.get('authenticated') !== 'true') {
            next({
                name: 'login',
                query: { redirect: to.fullPath }
            });
        } else if (to.meta.guards.includes('verified') && Cookies.get('verified') !== 'true') {
            next({
                name: 'confirm_email',
                query: { redirect: to.fullPath }
            });
        } else if (to.meta.guards.includes('unverified') && Cookies.get('verified') === 'true') {
            next({
                name: 'orders',
            });
        } else {
            next();
        }
    } else if (to.meta.guards.includes('guest') && Cookies.get('authenticated') === 'true') {
        next({
            name: 'orders'
        });
    } else {
        next();
    }
})

export default router;
